import Vue from 'vue'
import Vuex from 'vuex'
import app from '@/store/modules/app'
import systemUser from '@/store/modules/user'

import getters from './getters'
import common from './modules/common'
import menus from './modules/system/menus'
import boards from './modules/boards'
import linkGroups from './modules/link-groups'
import downloadStatus from './modules/download'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    common,
    systemUser,
    boards,
    linkGroups,
    downloadStatus,
    menus,
  },
  getters,
})
